// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"585c99fc","440":"0182632a","929":"4031e978"}[chunkId] + ".css";
};